/**
 * Константы для BillboardLoader
 * Централизованное хранение всех магических значений
 */
export const BILLBOARD_CONSTANTS = {
  // Текстуры
  DEFAULT_TEXTURE_PATH: 'images/authBg/bg-low.png',

  // Размеры столба
  POLE_HEIGHT: 8,
  POLE_RADIUS: 0.1,

  // Размеры доски
  BOARD_WIDTH: 6,
  BOARD_HEIGHT: 4.5,

  // Размеры основания
  BASE_RADIUS: 3.2,
  BASE_SEGMENTS: 32,

  // Trail Points System
  TRAIL_POINTS: 120,
  GLOW_SIZE: 0.5,
  GLOW_LENGTH: 1.2,
  RADIUS: 3,
  POINT_SCALE: 0.25,
} as const
